import { render } from "./BaseDialog.vue?vue&type=template&id=b6d5716e&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=b6d5716e&scoped=true&lang=css"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d5716e"]])

export default __exports__